<template>
  <div>
    <!-- Loader, if you need -->
    <CustomLoader v-if="isLoading" :width="70" />

    <!-- Fade transition -->
    <transition name="fade">
      <!-- We only render b-card if we have data (or use v-if="true" if guaranteed) -->
      <b-card v-if="formReady" class="mainCardBG animate__animated animate__fadeIn" :title="$route.name">
        <b-card-text>
          <!-- Navbar-like header, if you wish to keep the same style -->
          <b-navbar toggleable="lg" type="dark" variant="primary" class="mb-3" style="border-radius: 5px !important;">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="light">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>
                Back
              </b-button>
            </b-navbar-nav>

            <b-navbar-brand center>
              {{ formData.JobNo || 'No Job No' }}
              <b-button variant="success" size="sm" class="pull-right"
                v-if="formData.air_ct_shipping_bl_no && formData.air_ct_shipping_bl_date && formData.air_ct_shipper_inv_no && formData.air_ct_shipper_inv_date && formData.air_ct_cargo_gross_weight && formData.air_ct_cargo_net_weight && formData.air_ct_clearance_date && formData.air_ct_handover_date"
                @click="proceedToTally">Proceed To Invoice</b-button>
            </b-navbar-brand>
          </b-navbar>
          <banner-component :allModuleIdBanner="formData.fk_all_module_id ? formData.fk_all_module_id : ''
            " :jobSeriesBanner="formData.air_ct_job_no
              ? formData.air_ct_job_no
              : ''
            " :bannerClientName="formData.ClientName ? formData.ClientName : ''
            " iconId="fa fa-ship" />
          <b-card class="formCard">
            <b-card-text>
              <b-form @submit.stop.prevent="onSubmit">

                <!-- Basic Fields Row 1 -->
                <b-row>
                  <b-col cols="3" md="3">
                    <b-form-group label="Shipment Type" label-for="shipmentType">
                      <b-form-input id="shipmentType" :value="formData.air_ct_shipment_type_Txt"
                        :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_shipment_type_Txt">{{
                      errorCustomValidation.air_ct_shipment_type_Txt
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Job Type (CC,TPT,FF)" label-for="jobType">
                      <b-form-input id="jobType" :value="formData.air_ct_job_type" :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_job_type">{{
                      errorCustomValidation.air_ct_job_type
                      }}</span>
                  </b-col>
                  <!-- Job No -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Job Number" label-for="jobNo">
                      <b-form-input id="jobNo" v-model="formData.JobNo" :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.JobNo">{{
                      errorCustomValidation.JobNo
                      }}</span>
                  </b-col>
                  <b-col cols="3" md="3">
                    <b-form-group label="Client" label-for="ClientName">
                      <b-form-input id="ClientName" :value="formData.ClientName" :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.ClientName">{{
                      errorCustomValidation.ClientName
                      }}</span>
                  </b-col>

                  <!-- Airline -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Airline" label-for="airlineName">
                      <b-form-input id="airlineName" v-model="formData.Airline" :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.Airline">{{
                      errorCustomValidation.Airline
                      }}</span>
                  </b-col>


                  <!-- Departure -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Departure Airport" label-for="departureAirport">
                      <b-form-input id="departureAirport" v-model="formData.Departure" :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.Departure">{{
                      errorCustomValidation.Departure
                      }}</span>
                  </b-col>

                  <!-- Destination -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Destination Airport" label-for="destinationAirport">
                      <b-form-input id="destinationAirport" v-model="formData.Destination"
                        :readonly="true"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.Destination">{{
                      errorCustomValidation.Destination
                      }}</span>
                  </b-col>


                  <!-- Flight No -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Flight No" label-for="flightNo">
                      <b-form-input id="flightNo" v-model="formData.air_ct_flight_no"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_flight_no">{{
                      errorCustomValidation.air_ct_flight_no
                      }}</span>
                  </b-col>
                  <!-- Booking No -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Booking No" label-for="bookingNo">
                      <b-form-input id="bookingNo" v-model="formData.booking_no"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.booking_no">{{
                      errorCustomValidation.booking_no
                      }}</span>
                  </b-col>

                  <!-- MAWB Number -->
                  <b-col cols="3" md="3">
                    <b-form-group label="AWB BL Number" label-for="mawbNo">
                      <b-form-input id="awbNo" v-model="formData.air_ct_awb_bl_number"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_awb_bl_number">{{
                      errorCustomValidation.air_ct_awb_bl_number
                      }}</span>
                  </b-col>

                  <!-- MAWB Number -->
                  <b-col cols="3" md="3">
                    <b-form-group label="MAWB BL Number" label-for="mawbNo">
                      <b-form-input id="mawbNo" v-model="formData.air_ct_mawb_bl_number"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_mawb_bl_number">{{
                      errorCustomValidation.air_ct_mawb_bl_number
                      }}</span>
                  </b-col>

                  <!-- Shipping BL No -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Shipping BL No" label-for="shippingBlNo">
                      <b-form-input id="shippingBlNo" v-model="formData.air_ct_shipping_bl_no"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_shipping_bl_no">{{
                      errorCustomValidation.air_ct_shipping_bl_no
                      }}</span>
                  </b-col>

                  <!-- Shipper Invoice No -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Shipper Inv No" label-for="shipperInvNo">
                      <b-form-input id="shipperInvNo" v-model="formData.air_ct_shipper_inv_no"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_shipper_inv_no">{{
                      errorCustomValidation.air_ct_shipper_inv_no
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Gross Weight" label-for="grossWeight">
                      <b-form-input id="grossWeight" type="number"
                        v-model="formData.air_ct_cargo_gross_weight"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_cargo_gross_weight">{{
                      errorCustomValidation.air_ct_cargo_gross_weight
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Net Weight" label-for="netWeight">
                      <b-form-input id="netWeight" type="number"
                        v-model="formData.air_ct_cargo_net_weight"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_cargo_net_weight">{{
                      errorCustomValidation.air_ct_cargo_net_weight
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Volume Weight" label-for="volumeWeight">
                      <b-form-input id="volumeWeight" type="text"
                        v-model="formData.air_ct_cargo_volume_weight"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_cargo_volume_weight">{{
                      errorCustomValidation.air_ct_cargo_volume_weight
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Cargo Unit" label-for="cargoUnit">
                      <b-form-select id="cargoUnit" v-model="formData.air_ct_cargo_unit"
                        :options="['Kg', 'LBS', 'Others']"></b-form-select>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_cargo_unit">{{
                      errorCustomValidation.air_ct_cargo_unit
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Chargeable Wgt (Sys)" label-for="chargeSys">
                      <b-form-input id="chargeSys" type="number"
                        v-model="formData.air_ct_chargeable_weight_by_sys"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_chargeable_weight_by_sys">{{
                      errorCustomValidation.air_ct_chargeable_weight_by_sys
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Chargeable Wgt (Airline)" label-for="chargeAirline">
                      <b-form-input id="chargeAirline" type="number"
                        v-model="formData.air_ct_chargeable_weight_by_airline"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_chargeable_weight_by_airline">{{
                      errorCustomValidation.air_ct_chargeable_weight_by_airline
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Final Chargeable Wgt" label-for="chargeFinal">
                      <b-form-input id="chargeFinal" type="number"
                        v-model="formData.air_ct_chargeable_weight_final"></b-form-input>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_chargeable_weight_final">{{
                      errorCustomValidation.air_ct_chargeable_weight_final
                      }}</span>
                  </b-col>

                  <!-- Shipping BL Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Shipping BL Date" label-for="shippingBlDate">
                      <date-picker :format="selectDateFormat" lang="en" id="shippingBlDateObj" name="shippingBlDateObj"
                        v-model="formData.air_ct_shipping_bl_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_shipping_bl_date">{{
                      errorCustomValidation.air_ct_shipping_bl_date
                      }}</span>
                  </b-col>

                  <!-- Shipper Inv Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Shipper Inv Date" label-for="shipperInvDate">
                      <date-picker :format="selectDateFormat" lang="en" id="shipperInvDate" name="shipperInvDateObj"
                        v-model="formData.air_ct_shipper_inv_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_shipper_inv_date">{{
                      errorCustomValidation.air_ct_shipper_inv_date
                      }}</span>
                  </b-col>

                  <!-- Clearance Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Clearance Date" label-for="clearanceDate">
                      <date-picker :format="selectDateFormat" lang="en" id="clearanceDate" name="clearanceDateObj"
                        v-model="formData.air_ct_clearance_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_clearance_date">{{
                      errorCustomValidation.air_ct_clearance_date
                      }}</span>
                  </b-col>

                  <!-- Handover Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Handover Date" label-for="handoverDate">
                      <date-picker :format="selectDateFormat" lang="en" id="handoverDate" name="handoverDateObj"
                        v-model="formData.air_ct_handover_date"></date-picker>
                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_handover_date">{{
                      errorCustomValidation.air_ct_handover_date
                      }}</span>
                  </b-col>

                  <!-- Actual Departure Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Actual Departure" label-for="actualDepartureDate">
                      <date-picker :format="selectDateFormat" lang="en" id="actualDepartureDate"
                        name="actualDepartureDateObj" v-model="formData.air_ct_actual_departure_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_actual_departure_date">{{
                      errorCustomValidation.air_ct_actual_departure_date
                      }}</span>
                  </b-col>

                  <!-- Actual Arrival Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Actual Arrival" label-for="actualArrivalDate">
                      <date-picker :format="selectDateFormat" lang="en" id="actualArrivalDate"
                        name="actualArrivalDateObj" v-model="formData.air_ct_actual_arrival_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_actual_arrival_date">{{
                      errorCustomValidation.air_ct_actual_arrival_date
                      }}</span>
                  </b-col>

                  <!-- Expected Departure Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Expected Departure" label-for="expectedDepartureDate">
                      <date-picker :format="selectDateFormat" lang="en" id="expectedDepartureDate"
                        name="expectedDepartureDateObj" v-model="formData.air_ct_expected_departure_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_expected_departure_date">{{
                      errorCustomValidation.air_ct_expected_departure_date
                      }}</span>
                  </b-col>

                  <!-- Expected Arrival Date -->
                  <b-col cols="3" md="3">
                    <b-form-group label="Expected Arrival" label-for="expectedArrivalDate">
                      <date-picker :format="selectDateFormat" lang="en" id="expectedArrivalDate"
                        name="expectedArrivalDateObj" v-model="formData.air_ct_expected_arrival_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_expected_arrival_date">{{
                      errorCustomValidation.air_ct_expected_arrival_date
                      }}</span>
                  </b-col>
                  <b-col cols="3" md="3">
                    <b-form-group label="Flight Date" label-for="air_ct_flight_date">
                      <date-picker :format="selectDateFormat" lang="en" id="air_ct_flight_date"
                        name="air_ct_flight_date" v-model="formData.air_ct_flight_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_flight_date">{{
                      errorCustomValidation.air_ct_flight_date
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="MAWB Date" label-for="air_ct_mawb_bl_date">
                      <date-picker :format="selectDateFormat" lang="en" id="air_ct_mawb_bl_date"
                        name="air_ct_mawb_bl_date" v-model="formData.air_ct_mawb_bl_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_mawb_bl_date">{{
                      errorCustomValidation.air_ct_mawb_bl_date
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="AWB Date" label-for="air_ct_awb_bl_date">
                      <date-picker :format="selectDateFormat" lang="en" id="air_ct_awb_bl_date"
                        name="air_ct_awb_bl_date" v-model="formData.air_ct_awb_bl_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.air_ct_awb_bl_date">{{
                      errorCustomValidation.air_ct_awb_bl_date
                      }}</span>
                  </b-col>

                  <b-col cols="3" md="3">
                    <b-form-group label="Booking Date" label-for="booking_date">
                      <date-picker :format="selectDateFormat" lang="en" id="booking_date" name="booking_date"
                        v-model="formData.booking_date"></date-picker>

                    </b-form-group>
                    <span class="error" v-if="!formData.booking_date">{{
                      errorCustomValidation.booking_date
                      }}</span>
                  </b-col>


                  <b-col>
                    <b-button type="submit" variant="success" class="float-right">
                      Save Changes
                    </b-button>
                  </b-col>
                </b-row>

              </b-form>
            </b-card-text>

          </b-card>
        </b-card-text>
      </b-card>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

import BannerComponent from "../allModuleForm/bannerComponent.vue";
/**
 * IMPORTANT:
 *  1) Install Animate.css (npm install animate.css) 
 *  2) Then import it globally in main.js or here:
 *     import "animate.css";
 */

export default {

  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/airCCExportConsol");
      this.getSingleTPTCCAir();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  name: "AirFreightExportForm",

  components: {
    ModelListSelect,
    CustomLoader,
    DatePicker,
    BannerComponent,
  },

  props: {
    /**
     * The raw JSON response
     */
    airFreightData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectDateFormat,
      isLoading: false,
      formReady: false, // We'll toggle this once data is loaded for the fade transition
      formData: {},
      validate: true,

      // Date format for datepickers
      dateFormat: { year: "numeric", month: "short", day: "numeric" },

      // CUstom Validation Variable Declaration Start 23/06/2023
      errorCustomValidation: {
        air_ct_shipping_bl_no: "",
        air_ct_shipping_bl_date: "",
        air_ct_shipper_inv_no: "",
        air_ct_shipper_inv_date: "",
        air_ct_cargo_gross_weight: "",
        air_ct_cargo_net_weight: "",
        air_ct_clearance_date: "",
        air_ct_handover_date: "",
      },

      arrayErrorCustomValidation: [
        {
          air_ct_shipping_bl_no: "Enter Shipping Bl No. ",
          air_ct_shipping_bl_date: "Enter Shipping BL Date",
          air_ct_shipper_inv_no: "Enter Shipping Inv No. ",
          air_ct_shipper_inv_date: "Enter Shipping Inv Date",
          air_ct_cargo_gross_weight: "Enter Cargo Gross Weight",
          air_ct_cargo_net_weight: "Enter Cargo Net Weight",
          air_ct_clearance_date: "Enter Clearance Date",
          air_ct_handover_date: "Enter Handover Date",
        },
      ],
      // CUstom Validation Variable Declaration End 23/06/2023
    };
  },

  computed: {
    departureDisplay() {
      const master = this.formData.air_ct_airport_departure_pickuplocationmaster;
      return master ? master.pickupLocation : "";
    },
    destinationDisplay() {
      const master = this.formData.air_ct_airport_destination_pickuplocationmaster;
      return master ? master.pickupLocation : "";
    },
    shipmentTypeText() {
      return this.formData.air_ct_shipment_type_Txt || "";
    },
  },

  created() {
    // Copy prop into local data for easier usage
    this.formData = JSON.parse(JSON.stringify(this.airFreightData));

    // Convert date strings to Date objects
    this.shippingBlDateObj = this.toDateObject(this.formData.air_ct_shipping_bl_date);
    this.shipperInvDateObj = this.toDateObject(this.formData.air_ct_shipper_inv_date);
    this.clearanceDateObj = this.toDateObject(this.formData.air_ct_clearance_date);
    this.handoverDateObj = this.toDateObject(this.formData.air_ct_handover_date);
    this.actualDepartureDateObj = this.toDateObject(
      this.formData.air_ct_actual_departure_date
    );
    this.actualArrivalDateObj = this.toDateObject(
      this.formData.air_ct_actual_arrival_date
    );
    this.expectedDepartureDateObj = this.toDateObject(
      this.formData.air_ct_expected_departure_date
    );
    this.expectedArrivalDateObj = this.toDateObject(
      this.formData.air_ct_expected_arrival_date
    );

    // Slight delay so transition is smooth after data is ready
    setTimeout(() => {
      this.formReady = true;
    }, 100);
  },

  methods: {
    proceedToTally() {

      console.log("airFreightModel=>", this.formData)
      if (this.$route.path.split('/')[2] == 'airTPTExportConsol') {
        this.$router.push({
          path: "/airFreight/airTPTInvoice?JobType=TPT&ShipmentType=Air&ModuleType=" + this.formData.air_ct_transport_type + "&fk_all_module_id=" + this.$route.params.fk_all_module_id + "&air_ct_id=" + this.$route.params.air_ct_id
        });
      } else if (this.$route.path.split('/')[2] == 'airCCExportConsol') {
        this.$router.push({
          path: "/airFreight/airCCInvoice?JobType=CC&ShipmentType=Air&ModuleType=" + this.formData.air_ct_transport_type + "&fk_all_module_id=" + this.$route.params.fk_all_module_id + "&air_ct_id=" + this.$route.params.air_ct_id
        });
      } else if (this.$route.path.split('/')[2] == 'airCCImpConsol') {
        this.$router.push({
          path: "/airFreight/airCCInvoice?JobType=CC&ShipmentType=Air&ModuleType=" + this.formData.air_ct_transport_type + "&fk_all_module_id=" + this.$route.params.fk_all_module_id + "&air_ct_id=" + this.$route.params.air_ct_id
        });
      } else if (this.$route.path.split('/')[2] == 'airTPTImpConsol') {
        this.$router.push({
          path: "/airFreight/airTPTInvoice?JobType=TPT&ShipmentType=Air&ModuleType=" + this.formData.air_ct_transport_type + "&fk_all_module_id=" + this.$route.params.fk_all_module_id + "&air_ct_id=" + this.$route.params.air_ct_id
        });
      } else {
        this.$router.push({
          path: "/airFreight/airCCInvoice?JobType=CC&ShipmentType=Air&ModuleType=" + this.formData.air_ct_transport_type + "&fk_all_module_id=" + this.$route.params.fk_all_module_id + "&air_ct_id=" + this.$route.params.air_ct_id
        });
      }
     
    },
    toDateObject(dateStr) {
      if (!dateStr) return null;
      return new Date(dateStr);
    },
    toISOString(dateObj) {
      if (!dateObj) return null;
      return dateObj.toISOString();
    },

    getSingleTPTCCAir() {
      this.formData = {};
      this.isLoading = true;
      let payload = {
        fk_all_module_id: this.$route.params.fk_all_module_id,
        air_ct_id: this.$route.params.air_ct_id,
      }

      NodeLockPannelService.getSingleAir(payload.air_ct_id)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log('data=>', data)
          if (status == 200 && data) {
            this.formData = data.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAirList Error: ", error);
        });
    },

    // CUstom Validation Variable Declaration Start 23/06/2023
    validateAirCustomValidation() {
      let validate_new = true;
      Object.keys(this.errorCustomValidation).map((x, index) => {
        if (
          this.formData[x] == "" ||
          this.formData[x] == 0 ||
          this.formData[x] == undefined ||
          this.formData[x] == null ||
          this.formData[x] == "undefined" ||
          this.formData[x] == "null"
        ) {
          this.errorCustomValidation[x] = this.arrayErrorCustomValidation[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    onSubmit() {

      this.validateAirCustomValidation();
      console.log("this.errorCustomValidation=>", this.errorCustomValidation)
      console.log("this.errorCustomValidation validate=>", this.validate)
      if (this.validate == true) {
        this.isLoading = true;
        NodeLockPannelService.saveAir(this.formData)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log('data=>', data)
            if (status == 200 && data) {
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getAirList Error: ", error);
          });
      }
    },

    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
/* 
  1. Simple fade transition classes.
  2. Animate.css can be added to give animate__fadeIn, etc.
*/

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

.error {
  color: red;
}

.mainCardBG {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// airCCTPTConsol.vue?573967d2